//components/Login/login.js
import React, { useState, useEffect, useRef } from "react";
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userlogin } from "../slice/authService"
import { userLogin } from "../api/AuthService"
import { failed, success } from "../common/Toastify";
import TextInput from "../common/textfield/TextInput";
import { Button } from "../common/Button";
import User from '../../assets/images/person.png';
import Lock from '../../assets/images/Lock.png';
import Mail from '../../assets/images/mail.png';
import './login.css';
import MfaRespondModal from "./MfaRespondModal";
import { getMFASettings } from "../api/MFA";
import { getOrganization } from "../api/Organization";
import MFASetupModal from "../MFA/MFASetupModal";
import FonemedLogo from "../../assets/images/FoneMed-Logo.jpg";
import { useSelector } from "react-redux";
import { SAML_LOGIN_URL, COGNITO_CLIENT_ID, SAML_REDIRECT_URI, samlApiUrl } from "../../environment";
import { set } from "date-fns";
import PasskeyLogin from "../MFA/PasskeyLoginModal";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import IntservTokenValidation from "./intserv-token-validation";
import { validation, conditionalValidation } from "../../utils/constants";
import { POST_LOGIN_REDIRECT_KEY } from "../../utils/authUtils";
import { applySessionAuth } from "../../utils/sessionAuth";


function Login() {    
    const [searchParams] = useSearchParams();
    const [mfaResponseModalShow, setMFAResponseModalShow] = useState(false);
    const [authAppMFASessionToken, setAuthAppMFASessionToken] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [mfaAuthenticationResponse, setMfaAuthenticationResponse] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [btnLoading, setBtnLoading] = useState(false);
    const [mfaSetupModalShow, setMfaSetupModalShow] = useState(false);
    const [loginFormShow, setLoginFormShow] = useState(true);
    const [mfaChallenge, setMfaChallenge] = useState("");
    const [userId, setUserId] = useState("");
    const [orgId, setOrgId] = useState("");
    const [userData, setUserData] = useState({});
    const [token, setToken] = useState("");
    const [passkeyLoginModal, setPasskeyLoginModal] = useState(false);
    const [showPasskeyRegister, setShowPasskeyRegister] = useState(false);
    const [isIDPLogin, setIsIDPLogin] = useState(searchParams.get('isIDPLogin') === 'true' ? true : false);
    const [privacyModalShow, setPrivacyModalShow] = useState(false);
    const [apiTokenValidationModalShow, setApiTokenValidationModalShow] = useState(false);

    const handleToggleLoginMode = () => {
        setIsIDPLogin(!isIDPLogin);
        // Clear form values when switching modes
        formik.setValues({
            username: "",
            password: "",
            corporateEmail: "",
        });
        formik.setTouched({});
        formik.setErrors({});
    };

    const handleIDPClick = () => {
        window.location.href = `${SAML_LOGIN_URL}`;
    };

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
            corporateEmail: "",
        },
        validationSchema: yup.object({
            username: conditionalValidation(
                !isIDPLogin ? yup.string().required('Username Required').matches(/^$|^\S+.*/, 'Only blankspaces is not valid.') : yup.string(),
                {
                    validation,
                    label: "Username"
                }),
            password: conditionalValidation(
                !isIDPLogin ? yup.string().required('Password Required').matches(/^$|^\S+.*/, 'Only blankspaces is not valid.') : yup.string(),
                {
                    label: "Password"
                }),
            corporateEmail: conditionalValidation(
                isIDPLogin ? yup.string().required('Corporate Email Required').email('Please enter a valid email address') : yup.string(),
                {
                    validation,
                    label: "Corporate Email"
                }),
        }),
        onSubmit: (values) => {
            values.username = values?.username?.trim();
            values.password = values?.password?.trim();
            values.corporateEmail = values?.corporateEmail?.trim();
            if (isIDPLogin) {
                const email = values.corporateEmail;
                const domain = email.split('@')[1];
                const postLoginReturn = searchParams.get('redirect_uri');
                let idpUrl =
                    `${samlApiUrl}/oauth2/authorize?idp_identifier=${encodeURIComponent(domain)}` +
                    `&response_type=code&client_id=${encodeURIComponent(COGNITO_CLIENT_ID)}` +
                    `&redirect_uri=${encodeURIComponent(SAML_REDIRECT_URI)}` +
                    `&scope=email+openid+phone+profile&prompt=login`;
                if (postLoginReturn) {
                    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, postLoginReturn);
                    const statePayload = JSON.stringify({ returnTo: postLoginReturn });
                    idpUrl += `&state=${encodeURIComponent(statePayload)}`;
                }
                window.location.href = idpUrl;
                return;
            }

            values.username = values?.username?.toLowerCase();
            setBtnLoading(true);
            setUsername(values?.username);
            setPassword(values?.password);

            userLogin({ password: values.password, username: values.username?.toLowerCase() }).then((res) => {
                if (res.status === true) {
                    switch (res.authType) {
                        case "verify":
                            navigate("/auth/setpassword", { state: values });
                            break;
                        case "reset":
                            navigate("/auth/verifiedUserSetPass", { state: { username: values.username, session: res.session } });
                            break;
                        case "success":
                            let userResponse = res;
                            setUserData(userResponse.user);
                            setToken(userResponse?.refresh_token);
                            let orgId = res?.user?.organizations?.[0]?.id || res?.user?.["custom:orgId"];
                            let isUserMFAEnabled = false;
                            let isOrgMFAEnabled = false;
                            let userRole = res?.user?.["cognito:groups"];
                            let admin = userRole?.includes("Super-Admin");

                            if(userResponse?.user?.["custom:group"] === "API"){
                                // showingg a modal saying this is a valid API credentials and can be used to access the API
                                setApiTokenValidationModalShow(true);
                            } else {
                                getMFASettings({ username: values?.username })
                                    .then((res) => {
                                        if (res?.UserAttributes?.["custom:unique_id"]){
                                            setUserId(res?.UserAttributes?.["custom:unique_id"]);
                                        }
                                        if (res?.UserAttributes?.["custom:orgId"]){
                                            setOrgId(res?.UserAttributes?.["custom:orgId"]);
                                        }
                                        if (res?.UserMFASettingList && res.UserMFASettingList.length > 0) {
                                            isUserMFAEnabled = true;
                                        }
                                        getOrganization(orgId)
                                            .then((res) => {
                                                if (res?.data?.mfaSettings?.enabled === true) {
                                                    isOrgMFAEnabled = true;
                                                }
                                                if (isOrgMFAEnabled === true && isUserMFAEnabled === false) {
                                                    setLoginFormShow(false);
                                                    setShowPasskeyRegister(true);
                                                    setMfaSetupModalShow(true);
                                                } else if (isUserMFAEnabled === false && admin) {
                                                    setLoginFormShow(false);
                                                    setShowPasskeyRegister(true);
                                                    setMfaSetupModalShow(true);
                                                } else {
                                                    dispatch(userlogin(userResponse.user));
                                                    applySessionAuth(dispatch, {
                                                        accessToken: userResponse?.token ?? undefined,
                                                        refreshToken: userResponse?.refresh_token,
                                                    });
                                                    success("Successfully Logged In");
                                                }
                                            })
                                            .catch((res) => {
                                                failed(
                                                    res?.response?.data?.message ||
                                                    res?.response?.data?.error ||
                                                    res.message
                                                );
                                            });

                                    })
                                    .catch((res) => {
                                        failed(res?.message)
                                    })
                            }
                            break;
                        case "expire":
                            failed(res?.message || "Your password is expired. Please rest your password.");
                            break;
                        case "mfa":
                            navigate("/auth/verifyMFA", { state: { username: values.username, password: values.password } });
                            break;
                        default:
                            break;
                    }
                    
                } else {
                    if (res.authType === 'expire') {
                        failed(res?.message || "Your password is expired. Please rest your password.")
                        //navigate("/auth/reset-temporary-pass", { state: { email: values?.username } });
                    }

                    if (res?.authType === "validate-mfa") {
                        if(res?.mfaType === "CROSS_PLATFORM_MFA"){
                            setUserId(res?.userId);
                            setOrgId(res?.orgId);
                            setPasskeyLoginModal(true);
                        } else {
                            setMfaChallenge(res?.mfaType)
                            setAuthAppMFASessionToken(res?.session);
                            setMFAResponseModalShow(true);
                        }
                        
                    }

                    if (res.message !== "MFA is Enabled") {
                        failed(res.message);
                    }

                }

            }).finally(() => setBtnLoading(false));
        },
    });

    const idpAutoSubmitRef = useRef(false);

    useEffect(() => {
        if (idpAutoSubmitRef.current) return;
        if (searchParams.get("isIDPLogin") !== "true") return;
        const emailParam =
            searchParams.get("email")?.trim() ||
            searchParams.get("corporateEmail")?.trim();
        if (!emailParam) return;

        idpAutoSubmitRef.current = true;
        formik.setValues(
            {
                username: "",
                password: "",
                corporateEmail: emailParam,
            },
            false
        );
        Promise.resolve().then(() => {
            formik.submitForm();
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per mount when URL has IDP + email
    }, []);

    const handleMfaResponse = (data) => {
        setLoading(true);
        dispatch(userlogin(data.user));
        applySessionAuth(dispatch, {
            accessToken: data.token,
            refreshToken: data?.refresh_token,
        });
        success("Successfully Logged In");
    };

    const handlePrivacyModalShow = () => {
        setPrivacyModalShow(true)
    }
    

    return (
        <>
            {!loginFormShow && <>
                <div className="form-wrap">
                    <a href="#as" className="logo" title="Fonemed A Healthier Tomorrow">
                        <img src={FonemedLogo} alt="Fonemed A Healthier Tomorrow" />
                    </a>
                </div>
            </>}
            {loginFormShow &&
                <form className="custom-form" onSubmit={formik.handleSubmit}>
                    <h4>Login</h4>

                    {!isIDPLogin ? (
                        <>
                            <TextInput icon={User} keyField={"username"} label={"User name"} formik={formik} placeholder={"User name"} />
                            <TextInput type="password" icon={Lock} keyField={"password"} label={"Password"} formik={formik} placeholder={"Password"} />
                           <div className="page-link">
                                <Link to="/auth/forgotpassword" title="Forgot Password">Forgot Password?</Link>
                                <button 
                                    type="button" 
                                    onClick={handlePrivacyModalShow}
                                    className="link-button"
                                >
                                    Privacy Policy
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <TextInput icon={Mail} keyField={"corporateEmail"} label={"Corporate Email"} formik={formik} placeholder={"Enter your corporate email"} />
                        </>
                    )}
                    
                    <div className="btn-wrap" style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
                        <Button type="submit" className="custom-btn" isLoading={btnLoading}>
                            Login
                        </Button>
                        <Button
                            type="button" 
                            className="custom-btn" 
                            onClick={handleToggleLoginMode} 
                            variant="secondary"
                        >
                            {isIDPLogin ? "Login with Username" : "Login via IDP"}
                        </Button>
                    </div>
                </form>
            }
            {mfaSetupModalShow && <MFASetupModal modalShow={mfaSetupModalShow} handleClose={() => {
                setMfaSetupModalShow(false);
                setShowPasskeyRegister(false);
                setLoginFormShow(true);
            }} isFromLogin={true} passwordFromLogin={formik?.values?.password} usernameFromLogin={formik?.values?.username} user={userData} token={token} showPassKeyRegister={showPasskeyRegister} />}
            {mfaResponseModalShow && <MfaRespondModal modalShow={mfaResponseModalShow} handleClose={() => setMFAResponseModalShow(false)} username={username} session={authAppMFASessionToken} challengeName={mfaChallenge} onSuccess={handleMfaResponse} passwordFromLogin={formik?.values?.password}/>}
            {passkeyLoginModal && <PasskeyLogin userId={userId} orgId={orgId} username={username} password={password} handleClose={() => setPasskeyLoginModal(false)} modalShow={passkeyLoginModal} />}
            {privacyModalShow && <PrivacyPolicyModal handleClose={() => setPrivacyModalShow(false)} handleShow={privacyModalShow} />}
            {apiTokenValidationModalShow && <IntservTokenValidation modalShow={apiTokenValidationModalShow} handleClose={() => setApiTokenValidationModalShow(false)} />}
        </>
    );
}

export default Login;